<template>
    <div class="item-counter-container" :class="itemCounterColor">
        <p><i>{{getLabel}}</i>: <b>{{counterText}}</b></p>
    </div>
</template>

<script>
    export default {
        name: "ItemsCounter",
        props: {
            count: Number,
            maxCount: Number,
            label: String
        },
        data() {
            return {
                currentCount: this.count,
                max: this.maxCount
            }
        },
        computed: {
            getLabel() {
              return this.label ? this.label : '';
            },
            counterText() {
                return this.currentCount + ' / ' + this.max;
            },
            itemCounterColor() {
                let styleClass = 'item-counter-color-';
                if (this.currentCount === 0) {
                    styleClass += 'grey';
                } else {
                    if (this.currentCount < this.max) {
                        styleClass += 'blue';
                    } else {
                        if (this.currentCount === this.max) {
                            styleClass += 'yellow';
                        } else {
                            if (this.currentCount > this.max) {
                                styleClass += 'red';
                            }
                        }
                    }
                }

                return styleClass;
            }
        },
        watch: {
            count(newVal) {
                this.currentCount = newVal;
            },
            maxCount(newVal) {
                this.max = newVal;
            },
            alert(newVal) {
                this.shouldAlert = newVal;
            }
        }
    }
</script>

<style scoped>
    .item-counter-container {
        width: fit-content;
        height: fit-content;
        border: 1px solid transparent;
        border-radius: 50px;
        display: inline-block;
        padding: 5px 15px;
    }

    .item-counter-color-blue {
        color: var(--primary-blue);
        border-color: var(--primary-blue);
        background-color: var(--very-light-blue);
    }

    .item-counter-color-yellow {
        color: var(--dark-yellow);
        border-color: var(--dark-yellow);
        background-color: var(--very-light-yellow);
    }

    .item-counter-color-red {
        color: var(--primary-red);
        border-color: var(--primary-red);
        background-color: var(--very-light-red);
    }

    .item-counter-color-grey {
        color: var(--grey);
        border-color: var(--grey);
        background-color: var(--lightest-grey);
    }
</style>